import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ACCOUNT, MODAL, SETTING } from '../../reduxs'
import {
  setLocalStorage,
  setSessionStorage,
  getLocalStorage,
  getSessionStorage,
  removeLocalStorage,
  TEXT_ENCRYPT,
  ROUTE,
  LOG_IN,
  LOGIN_TYPE
} from '../../helpers'
import { StyleLogin } from './style'
import { IMG, COLOR, FONT_SIZE } from '../../themes'
import {
  ButtonLogin,
  Validate,
  ModalStatus,
  Loader,
  ModalResetPassword,
  ButtonGoogleLogin,
  ButtonMicrosoftLogin
} from '../../components'
import ReactGA from "react-ga";
import { GoogleOAuthProvider } from '@react-oauth/google'
import MsalWrapper from './MsalWrapper'
import { loginRequest } from '../../configs'

export class Login extends Component {
  constructor(props) {
    super(props)

    const user = getLocalStorage(TEXT_ENCRYPT.ACCOUNT) || getSessionStorage(TEXT_ENCRYPT.ACCOUNT)
    const pass = getLocalStorage(TEXT_ENCRYPT.PASS) || getSessionStorage(TEXT_ENCRYPT.PASS)
    this.state = {
      userName: user !== null ?
        user.replace(TEXT_ENCRYPT.ACCOUNT, '').replace(TEXT_ENCRYPT.ACCOUNT, '')
        :
        '',
      password: pass !== null ?
        pass.replace(TEXT_ENCRYPT.PASS, '').replace(TEXT_ENCRYPT.PASS, '')
        :
        '',
      errorUserId: '',
      errorPassword: '',
      errorUsername: '',
      checked: false,
      confirm: false,
      forgotPassword: false,
      seePassword: false,
    }
    //GA TrackingId
    ReactGA.initialize("UA-153387162-1");
    ReactGA.pageview("Login Page")

    props.checkSection(props.history)
  }

  routeChange = () => {
    const date = new Date()
    let path = `${ROUTE.CALENDAR.LINK}/month/${date.getFullYear()}/${date.getMonth()+1}/${date.getDate()}`
    this.props.history.push(path)
  }

  showPassword = () => {
    this.setState((previousState) => ({
      seePassword: !previousState.seePassword
    }))
  }

  onChangeInput = {
    userName: event => {
      this.setState({
        userName: event.target.value,
        errorUserId: '',
        errorUsername: '',
      }, () => {
        const {
          modalAction
        } = this.props
        modalAction.clearValidate()
      })
    },
    password: event => {
      this.setState({
        password: event.target.value,
        errorPassword: '',
        errorUsername: '',
      }, () => {
        const {
          modalAction
        } = this.props
        modalAction.clearValidate()
      })
    }
  }

  confirmLogin = () => {
    const { userName, password, checked } = this.state
    const { accountAction, history } = this.props
    const param = {
      username: String(userName),
      password: String(password),
    }

    if (checked) {
      setLocalStorage(TEXT_ENCRYPT.ACCOUNT, `${TEXT_ENCRYPT.ACCOUNT}${userName}${TEXT_ENCRYPT.ACCOUNT}`)
      setLocalStorage(TEXT_ENCRYPT.PASS, `${TEXT_ENCRYPT.PASS}${password}${TEXT_ENCRYPT.PASS}`)
    } else {
      removeLocalStorage(TEXT_ENCRYPT.ACCOUNT)
      removeLocalStorage(TEXT_ENCRYPT.PASS)
      removeLocalStorage(TEXT_ENCRYPT.ACCESS_TOKEN)
    }

    setLocalStorage(TEXT_ENCRYPT.ACCOUNT, `${TEXT_ENCRYPT.ACCOUNT}${userName}${TEXT_ENCRYPT.ACCOUNT}`)
    setLocalStorage(TEXT_ENCRYPT.PASS, `${TEXT_ENCRYPT.PASS}${password}${TEXT_ENCRYPT.PASS}`)
    setSessionStorage(TEXT_ENCRYPT.ACCOUNT, `${TEXT_ENCRYPT.ACCOUNT}${userName}${TEXT_ENCRYPT.ACCOUNT}`)
    setSessionStorage(TEXT_ENCRYPT.PASS, `${TEXT_ENCRYPT.PASS}${password}${TEXT_ENCRYPT.PASS}`)
    accountAction.loginUser(param, history, this.routeChange)
  }

  enter = (e) => {
    if (e.key === 'Enter') {
      this.checkInput()
    }
  }

  checkInput = () => {
    const { userName, password } = this.state;
    let errors = {};
  
    if (userName === '') {
      errors.errorUserId = 'Incorrect username. Please try again.';
    }
  
    if (password === '') {
      errors.errorPassword = 'Incorrect password. Please try again.';
    }
  
    if (Object.keys(errors).length === 0) {
      if (!this.checkUsername()) {
        errors.errorUsername = 'Username or Password is incorrect.';
      } else {
        this.confirmLogin();
      }
    }
  
    if (Object.keys(errors).length > 0) {
      this.setState(errors);
    }
  
    this.trackingLoginButton();
  }

  checkUsername = ()=> {
    const {userName}= this.state
    const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return emailPattern.test(userName)
  }

  clickRemember = () => {
    this.setState((previousState) => ({
      checked: !previousState.checked
    }))
  }

  modal = {
    closeModalStatus: () => {
      const {
        modalAction
      } = this.props
      modalAction.closeModalStatus()
    }
  }

  forgotPassword = () => {
    this.setState({
      forgotPassword: true
    })
  }

  closeModalResetPassword = () => {
    this.setState({
      forgotPassword: false
    })
  }

  resetPasswordSendEmailUser = (email, func = () => {}) =>{
    const {
      accountAction
    } = this.props

    accountAction.resetPasswordSendEmailUser({
      username: email,
    },() => {
      func()
    })
  }

  trackingLoginButton() {
    ReactGA.event({
      category: "Login",
      action: "Login_Button",
    });
  }

  handleGoogleSuccessLogin = (authData) => {
    if (authData) {
      const { accountAction, history } = this.props
      const param = { accessToken: authData.access_token, type: LOGIN_TYPE.GOOGLE }
      removeLocalStorage(TEXT_ENCRYPT.ACCOUNT)
      removeLocalStorage(TEXT_ENCRYPT.PASS)
      removeLocalStorage(TEXT_ENCRYPT.ACCESS_TOKEN)
      this.clearAllValue()
      accountAction.loginUser(param, history, this.routeChange)
    }
  }

  handleMicrosoftLogin = (error, authData) => {
    if(error){
      console.error(error)
      return
    }

    const { accountAction, history } = this.props
    const param = { accessToken: authData.accessToken, type: LOGIN_TYPE.MICROSOFT}
    removeLocalStorage(TEXT_ENCRYPT.ACCOUNT)
    removeLocalStorage(TEXT_ENCRYPT.PASS)
    removeLocalStorage(TEXT_ENCRYPT.ACCESS_TOKEN)
    this.clearAllValue()
    accountAction.loginUser(param, history, this.routeChange)
  }

  handleLogin = () => {
    this.props.instance
      .loginPopup(loginRequest)
      .then((authData) => {
        const { accountAction, history } = this.props
        const param = { accessToken: authData.accessToken, type: LOGIN_TYPE.MICROSOFT}
        removeLocalStorage(TEXT_ENCRYPT.ACCOUNT)
        removeLocalStorage(TEXT_ENCRYPT.PASS)
        removeLocalStorage(TEXT_ENCRYPT.ACCESS_TOKEN)
        this.clearAllValue()
        accountAction.loginUser(param, history, this.routeChange)
      })
      .catch((e) => {
        console.error('handleLogin error:', e);
      })
  }

  clearAllValue = ()=>{
    this.setState({
      userName: '',
      password: '',
      errorUserId: '',
      errorPassword: '',
      errorUsername: '',
      checked: false,
      confirm: false,
      forgotPassword: false,
    })
  }

  render() {
    const {
      userName,
      password,
      errorUserId,
      errorUsername,
      checked,
      errorPassword,
      forgotPassword,
      seePassword
    } = this.state

    const {
      modalReducer,
      loaderReducer,
      accountReducer,
      settingReducer
    } = this.props

    const { colorTheme } = settingReducer.settingTheme

    return (
      <StyleLogin>

        {loaderReducer.isDisplay && <Loader colorTheme={colorTheme} />}

        {modalReducer.status &&
          <ModalStatus
            language={accountReducer.language}
            code={modalReducer.status.code}
            text={modalReducer.status.description}
            status={modalReducer.status.status}
            onClick={this.modal.closeModalStatus}
            colorTheme={colorTheme}
          />
        }

        {
          forgotPassword &&
          <ModalResetPassword
            onClickBack={this.closeModalResetPassword}
            resetPasswordSendEmailUser={this.resetPasswordSendEmailUser}
            language={accountReducer.language}
            colorTheme={colorTheme}
          />
        }

        <div className = 'container'>
          <div
            className = 'bg-logo'
            style={{ backgroundColor: COLOR.BLACK_1, height: 'auto' }}
          >
            <div className = 'content-logo'>
              <img
                src={IMG['vichai_logo.svg']}
                alt='logo'
              />
            </div>
          </div>

          <div className='content-login'>
            <div className='box-login'>
            <div className='welcome-label'>{ LOG_IN.MEMBER_LOGIN[accountReducer.language] }</div>
            <div className='welcome-label2'>{LOG_IN.WELCOME_BACK_SUB[accountReducer.language]}</div>

            <div className='username-password'>
              <div>{LOG_IN.USERNAME[accountReducer.language]}</div>
              <div className='username-password-input' style={{ border: `1px solid ${
                  errorUserId ? COLOR['RED_2'] : COLOR['GOLD_2']
                }` }}
              >
              <input
                style={{
                color: `${COLOR.GOLD_1}`,
                fontSize: `${FONT_SIZE.SM}`,
                flexGrow: 1,
                border: 'none',
                width: '100%',
                }}
                value={userName}
                onChange={this.onChangeInput.userName}
              />
              </div>
              <Validate className='validate' text={errorUserId} />

              <div className='password'>{LOG_IN.PASSWORD[accountReducer.language]}</div>
              <div className='username-password-input password-part' style={{
                border: `1px solid ${errorPassword !== '' && errorPassword ? COLOR['RED_2'] : COLOR['GOLD_2']}`,
              }}>
                <input
                  style={{
                    color: `${COLOR.GOLD_1}`,
                    fontSize: `${FONT_SIZE.SM}`,
                    flexGrow: 1,
                    border: 'none',
                    width: '100%',
                  }}
                  value={password}
                  onChange={this.onChangeInput.password}
                  type={seePassword ? 'text' : 'password'}
                  onKeyDown={this.enter}
                />
                <div onClick={this.showPassword}>
                <img
                  width='24px'
                  height='24px'
                  src={IMG[seePassword ? 'eye.svg' : 'eyeClose.svg']}
                  alt='logo'
                />
                </div>
              </div>
              <Validate className='validate' text={errorUsername} />
              <Validate className='validate' text={errorPassword !== '' ?
                errorPassword
                :
                modalReducer.validate && modalReducer.validate.messageKey !== 'emailTokenNotFound'
                ? modalReducer.validate.description : ''}
              />

            </div>

            <div className='remember-me'>
              <input
                type='checkbox'
                checked={checked}
                onChange={this.clickRemember}
              />
              <label> {LOG_IN.REMEMBER_ME[accountReducer.language]} </label>
            </div>

            <div className='sigin'>
              <ButtonLogin
                icon={'sing_in.svg'}
                name={LOG_IN.SIGN_IN[accountReducer.language]}
                onClick={this.checkInput}
              />
            </div>

            <div className='forgot'>
              <div className='forgot-link' onClick={this.forgotPassword}>{LOG_IN.FORGOT_PASSWORD[accountReducer.language]}</div>
            </div>

            <div className='login-with'>
            <div className='or-container'>
              <div className='line-hr'>
                <hr />
              </div>
              <p className='or-text'>or</p>
              <div className='line-hr'>
                <hr />
              </div>
            </div>
            <div className='login'>
              <div>
                <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
                  <ButtonGoogleLogin onSuccess={this.handleGoogleSuccessLogin} />
                </GoogleOAuthProvider>
              </div>
              <div>
                <ButtonMicrosoftLogin onClick={this.handleLogin} image={IMG['microsoft-logo.svg']} text={LOG_IN.LOGIN_MICROSOFT['EN']} />
              </div>
            </div>
          </div>
          </div>
          </div>
        </div>
     </StyleLogin>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    accountAction: bindActionCreators(ACCOUNT.action, dispatch),
    modalAction: bindActionCreators(MODAL.action, dispatch),
    settingAction: bindActionCreators(SETTING.action, dispatch)
  }
}

export const mapStateToProps = ({
  accountReducer,
  modalReducer,
  loaderReducer,
  settingReducer
}) => {
  return {
    modalReducer,
    accountReducer,
    loaderReducer,
    settingReducer
  }
}

const ConnectedLogin = connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);

export default MsalWrapper(ConnectedLogin);
